import { authHeader } from '../helpers/authHeader';
import { handleAxiosResponse, api_base_url, axiosInstance } from '../services/common.services';
import { handleServiceRequest } from '../services/handleServiceRequest';
import NotificationService from "./NotificationService";

export const businessYearService = {
    getBusinessYears,
    createNewYear,
    makeYearCurrent,
    getBusinessYear,
    getPriceBrackets,
    getPriceAdjustments,
    getAreaSchedule,
    getBlackoutSchedule,
    updatePriceBracket,
    updateBlackoutDate,
    updateSeasonalInfo,
    updateAreaSchedule,
    updatePriceAdjustments,
    createPriceBracket,
    createBlackoutDate,
    createAreaSchedule,
    createPriceAdjustments,
    getCurrentBusinessYear,
    deleteAreaSchedule,
    deletePriceAdjustment,
    deleteBlackoutSchedule,
    deletePriceBracket,
    copyJobsFromPreviousYear(year) {
        const object = {
            url: `${baseUrl}/${year}/copy-customer-jobs`,
            postBody: {year: year},
            customErrorMessage: `Failed to start set up of customer jobs`,
        };
        return handleServiceRequest.post(object);
    }
};
const baseUrl = `/api/business-years`;

function getBusinessYears(): Promise<any>  {
    const getObject = {
        url: `${baseUrl}`,
        customErrorMessage: 'Failed to get Business Years'
    };
    return handleServiceRequest.get(getObject).then((res) => {
        return res;
    });
}

function getBusinessYear(year): Promise<any>  {
    const getObject = {
        url: `${baseUrl}/${year}`,
        customErrorMessage: `Failed to get Business Year ${year}`
    };
    return handleServiceRequest.get(getObject).then((res) => {
        return res;
    });
}

function getPriceBrackets(year): Promise<any>  {
    const getObject = {
        url: `${baseUrl}/${year}/price-brackets`,
        customErrorMessage: `Failed to get price brackets`

    };
    return handleServiceRequest.get(getObject).then((res) => {
        return res;
    });
}

function deletePriceBracket(year, recordId): Promise<any>  {
    const getObject = {
        url: `${baseUrl}/${year}/price-brackets/${recordId}`,
        customErrorMessage: `Failed to delete price bracket ${recordId}`
    };
    return handleServiceRequest.deleteItem(getObject).then((res) => {
        return res;
    });
}
function deleteBlackoutSchedule(year, recordId): Promise<any>  {
    const getObject = {
        url: `${baseUrl}/${year}/blackout-dates/${recordId}`,
        customErrorMessage: `Failed to delete blackout date ${recordId}`
        
    };
    return handleServiceRequest.deleteItem(getObject).then((res) => {
        return res;
    });
}
function deleteAreaSchedule(year, recordId): Promise<any>  {
    const getObject = {
        url: `${baseUrl}/${year}/area-schedules/${recordId}`,
        customErrorMessage: `Failed to delete area schedule ${recordId}`
    };
    return handleServiceRequest.deleteItem(getObject).then((res) => {
        return res;
    });
}
function deletePriceAdjustment(year, recordId): Promise<any>  {
    const getObject = {
        url: `${baseUrl}/${year}/price-adjustments/${recordId}`,
        customErrorMessage: `Failed to delete price adjustment ${recordId}`
    };
    return handleServiceRequest.deleteItem(getObject).then((res) => {
        return res;
    });
}

function getBlackoutSchedule(year): Promise<any>  {
    const getObject = {
        url: `${baseUrl}/${year}/blackout-dates`,
        customErrorMessage: `Failed to get blackout dates for ${year}`
    };
    return handleServiceRequest.get(getObject).then((res) => {
        return res;
    });
}

function getAreaSchedule(year): Promise<any>  {
    const getObject = {
        url: `${baseUrl}/${year}/area-schedules`,
        customErrorMessage: `Failed to get area schedule for ${year}`

    };
    return handleServiceRequest.get(getObject).then((res) => {
        return res;
    });
}

function getPriceAdjustments(year): Promise<any>  {
    const getObject = {
        url: `${baseUrl}/${year}/price-adjustments`,
        customErrorMessage: `Failed to get price adjustments for ${year}`
    };
    return handleServiceRequest.get(getObject).then((res) => {
        return res;
    });
}

function updatePriceBracket(postData, year): Promise<any> {
    const object = {
        url: `${baseUrl}/${year}/price-brackets/${postData.priceBracketId}`,
        customErrorMessage: `Failed to update price bracket for ${year}`,
        postBody: postData
    };
    return handleServiceRequest.put(object);
}

function updateBlackoutDate(postData, year): Promise<any> {
    const object = {
        url: `${baseUrl}/${year}/blackout-dates/${postData.blackoutDateId}`,
        customErrorMessage: `Failed to update backout date for ${year}`,
        postBody: postData
    };
    return handleServiceRequest.put(object);
}

function updateAreaSchedule(postData, year): Promise<any> {
    const object = {
        url: `${baseUrl}/${year}/area-schedules/${postData.areaScheduleId}`,
        customErrorMessage: `Failed to update area schedule for ${year}`,
        postBody: postData
    };
    return handleServiceRequest.put(object);
}

function updatePriceAdjustments(postData, year): Promise<any> {
    const object = {
        url: `${baseUrl}/${year}/price-adjustments/${postData.priceAdjustmentId}`,
        customErrorMessage: `Failed to update price adjustments for ${year}`,
        postBody: postData
    };
    return handleServiceRequest.put(object);
}

function updateSeasonalInfo(postData, year): Promise<any> {
    const object = {
        url: `${baseUrl}/${year}`,
        customErrorMessage: `Failed to update seasonal dates for ${year}`,
        postBody: postData
    };
    return handleServiceRequest.put(object);
}

function createBlackoutDate(postData, year): Promise<any> {
    const object = {
        url: `${baseUrl}/${year}/blackout-dates`,
        customErrorMessage: `Failed to create blackout date for ${year}`,
        postBody: postData
    };
    return handleServiceRequest.post(object);
}
function createPriceBracket(postData, year): Promise<any> {
    const object = {
        url: `${baseUrl}/${year}/price-brackets`,
        postBody: postData
    };
    return handleServiceRequest.post(object);
}

function createAreaSchedule(postData, year): Promise<any> {
    const object = {
        url: `${baseUrl}/${year}/area-schedules`,
        customErrorMessage: `Failed to create area schedule for ${year}`,
        postBody: postData
    };
    return handleServiceRequest.post(object);
}

function createPriceAdjustments(postData, year): Promise<any> {
    const object = {
        url: `${baseUrl}/${year}/price-adjustments`,
        customErrorMessage: `Failed to create price adjustment for ${year}`,
        postBody: postData
    };
    return handleServiceRequest.post(object);
}


function createNewYear(year: number): Promise<any>  {
    const getObject = {
        url: `${baseUrl}/${year}`,
        customErrorMessage: `Failed to create new year for ${year}`,
        postBody: {},
    };
    return handleServiceRequest.post(getObject).then((res) => {
        return res;
    });
}

function makeYearCurrent(year: number): Promise<any>  {
    const obj = {
        url: `${baseUrl}/${year}/current`,
        customErrorMessage: `Failed to make ${year} the current year`,
        postBody: {},
    };
    return handleServiceRequest.put(obj);
}

async function getCurrentBusinessYear(): Promise<any> {
    const years = await getBusinessYears();
    const current = years.find(x => x.current);
    if (!current) throw new Error("No current business year found");
    return current;
}